import { ReactNode, useState } from 'react';
import { createSignalRContext } from 'react-signalr';
import { CallbackMethodNames, OneSignalR, ServerOperations } from '../models/signalR.types';
import { DashboardTile } from '../pages/Dashboard/Dashboard.types';
import EnvWindow from '../utils/env';
import { SignalRCustomProvider } from './SignalRCustom.context';
/**
 * Example of usage in the component:
 *
 * import { SignalRContext } from '../../Context/SignalR.context';
 *
 * const Component = () => {
 *  //1. Listening for 'SendFromServer' method:
 *  SignalRContext.useSignalREffect(
 *   'SendFromServer',
 *   (message) => {
 *     console.log('Received SendFromServer: ', message);
 *   },
 *   [],
 *  );
 *
 *  //2. Calling SendToServer method:
 *  SignalRContext.invoke('SendToServer', 'userId', Math.random().toString());
 * }
 */
export const SignalRContext = createSignalRContext<OneSignalR>({ shareConnectionBetweenTab: true });

export const SignalRProvider: React.FC<{ children: ReactNode; disabled?: boolean }> = ({ children, disabled }) => {
  const [messages, setMessages] = useState<string[]>([]);
  SignalRContext.useSignalREffect(
    CallbackMethodNames.SendFromServer,
    (message) => {
      setMessages([...messages, message]);
      if (EnvWindow.REACT_APP_DXC_ENV) console.log(message);
    },
    [messages],
  );

  return (
    <SignalRCustomProvider<OneSignalR>
      context={SignalRContext}
      url={EnvWindow.REACT_APP_WEBSOCKET_URL}
      disabled={disabled}
    >
      {children}
    </SignalRCustomProvider>
  );
};

export const leaveAssessmentSession = (session: DashboardTile | null): void => {
  if (session) {
    SignalRContext.invoke(ServerOperations.LeftAssessmentSession, session.assessmentSessionId);
  }
};
